<template>
    <div class="wraper">
        <div class="search_input">
            <fa :icon="['fal', 'search']"></fa>
            <input type="text" placeholder="Search contacts" class="w-full" @input="(e) => emits('handleInput', e.target.value)" />
        </div>
    </div>
</template>
<script setup>
import { ref } from "vue";
import { getAutoCompleteResults } from "@/api/AutoComplete";
import { contactsList } from "../../../../stores/contactsStore";

const emits = defineEmits(["handleInput"]);

const searchInput = ref("");

const getContacts = async () => {
    if (searchInput.value.trim() === "") return console.error("Empty input value");
    const response = await getAutoCompleteResults(searchInput.value, "contact", 15);

    if (response.status === "Success") {
        contactsList.contacts = response.data;
        console.log(contactsList.contacts);
    }
};
</script>
<style scoped>
.search_input {
    height: 40px;
    gap: 4px;
    border-radius: 99px;
    border: 1px solid #dde3e4;
    opacity: 0px;
    background: #ebecec;
    display: flex;
    align-items: center;
    @apply my-2;
}
.search_input svg {
    font-size: 24px;
    font-weight: 300;
    line-height: 24px;
    text-align: left;
    font-size: 24px;
    color: #bac4cd;
    margin: 0px 4px 0px 12px;
}
.search_input input {
    border: none !important;
    outline: none !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
    background: transparent;
}
.search_input input::placeholder {
    color: #bac4cd;
    font-size: 14px;
    font-weight: 500;
    line-height: 16.94px;
    text-align: left;
}
</style>
